/**
 * Onboarding done (S05) — workspace ready, trial state, and forward handoff.
 *
 * @see prototype/onboarding/done.html — V1.1 Studio Slate baseline
 */
import { createFileRoute } from "@tanstack/react-router";
import {
  OnboardingShell,
  OnboardingHeader,
  Stepper,
  Hero,
  HeroNote,
  BrandFor,
  STEP_TITLES,
} from "../../../features/onboarding/components/index.ts";
import { DoneSummary } from "../../../features/onboarding/components/done-summary.tsx";

export const Route = createFileRoute("/(auth)/onboarding/done")({
  component: OnboardingDone,
});

function OnboardingDone() {
  return (
    <OnboardingShell
      header={
        <OnboardingHeader
          center={<Stepper current={4} done titles={STEP_TITLES} />}
        />
      }
      brand={<BrandFor step="done" />}
      footer="Trial started · billing activation happens later inside the workspace"
    >
      <Hero
        kicker="Workspace ready"
        kickerTone="ok"
        title="Your company is live. The free trial has started."
        description="Phone verification is complete, the workspace exists, and migration can happen later without blocking the first real workflow."
      >
        <HeroNote>Activate billing before the trial ends to keep writing new data.</HeroNote>
      </Hero>
      <DoneSummary />
    </OnboardingShell>
  );
}
